import React, { useEffect, useState, useMemo, useRef } from "react";
import "./OrderPlanSearchResultCard.scss";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../../api/API-Url";
import ThemeBtn from "../ThemeBtn/ThemeBtn";
import dayjs from 'dayjs';
import CalenderComponent from "../CalenderComponent/CalenderComponent";
import TimeRangeSelector from "../TimeRangeSelector/TimeRangeSelector";
import { getAllCities } from "../../commons/activity-filters/Helpers";


function OrderPlanSearchResultCard(props) {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);
    const [showDropdown, setShowDropdown] = React.useState(false);


    const fallbackImage = "https://funtlers.com/static/media/booking-confirmation-img.8df3502e7365d6433146.png"; // Fallback image
    // ...existing code...

    const [showDatePicker, setShowDatePicker] = useState(false);

    const datePickerRef = useRef(null);
    const dropdownRef = useRef(null);

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            
            if (event.target.classList.length>0) {
                setShowDropdown(false);


            }

        }
    };




    useEffect(() => {
        if (showDropdown) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        // Cleanup
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showDropdown]);


    // Close date picker when clicking outside
    useEffect(() => {
        if (!showDatePicker) return;

        function handleClickOutside(event) {
            if (datePickerRef.current && !datePickerRef.current.contains(event.target)) {
                setShowDatePicker(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDatePicker]);


    // In handleDateChange
    const handleDateChange = (date) => {
        
        setShowDatePicker(false);
        if (props.onDateChange) {
            props.onDateChange(activity.id, date ? date : null);
        } else {
            activity.addDate = date ;
        }
    };


    let activity;
    //the rerouting from this component will be different if it is coming from customer side.
    if (props.source === "customer") {
        activity = props.Data;
        activity.userType = "customer";
    } else activity = props.activity;
            
    let res = activity.name.replace(/ /g, '-');
    res = res.replace(/\//g, '-');
    res = res.replace(/\?/g, '');


    


    const navigate = useNavigate();

    function DateFormat(date) {
        // Parse the input date into a JavaScript Date object
        const parsedDate = new Date(date);

        // Use Intl.DateTimeFormat to format the date in Norwegian
        let formattedDate = new Intl.DateTimeFormat('no-NO', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        }).format(parsedDate);

        // Split the formatted date to capitalize only the first letter of the month
        const parts = formattedDate.split(' ');
        const month = parts[1].charAt(0)?.toUpperCase() + parts[1].slice(1); // Capitalize the first letter of the month
        parts[1] = month; // Replace the month part with the capitalized version

        // Rejoin the parts and return the formatted date
        return parts.join(' ');
    }

    const toActivityDetails = () => {
        if (activity.isCustomActivity && props.onShowCustomActivityDetails) {
            props.onShowCustomActivityDetails(activity);
            return;
        }
        if (props.source === "customer" || props.source === "partner") {
            localStorage.setItem('aktiviteter', activity.id);
            return navigate("/aktivitet/" + res + "?id=" + activity.id + "&type=B2B");
        }
        if (window.location.pathname === '/partner-aktiviteter')
            localStorage.setItem('partner-aktiviteter', props.partnerId);
        if (window.location.pathname === '/aktivitet-side')
            localStorage.setItem('aktivitet-side', activity.id);
        navigate("/redigere-aktivitet", { state: activity });
    };

    const toActivityDetailsURL = () => {
        if (activity.isCustomActivity && props.onShowCustomActivityDetails) {
            //props.onShowCustomActivityDetails(activity);
            return;
        }
        if (props.source === "customer" || props.source === "partner") {
            localStorage.setItem('aktiviteter', activity.id);
            return ("/aktivitet/" + res + "?id=" + activity.id + "&type=B2B");
        }
        if (window.location.pathname === '/partner-aktiviteter')
            localStorage.setItem('partner-aktiviteter', props.partnerId);
        if (window.location.pathname === '/aktivitet-side')
            localStorage.setItem('aktivitet-side', activity.id);
        return ("/redigere-aktivitet", { state: activity });
    };

    const [tempAddDate, setTempAddDate] = useState(activity.addDate ? dayjs(activity.addDate) : null);
    const [tempFromTime, setTempFromTime] = useState(activity.fromTime);
    const [tempToTime, setTempToTime] = useState(activity.toTime);


    useEffect(() => {
        if (!showDropdown) {
            setTempAddDate(activity?.addDate ? dayjs(activity.addDate) : null);
            setTempFromTime(activity?.fromTime);
            setTempToTime(activity?.toTime);
        }
    }, [showDropdown, activity?.addDate, activity?.fromTime, activity?.toTime]);


    return (
        <>

            {props.isType && props.isType == "recommend-2" && props?.mode !== "isEditAdminRequest" && (
                <>
                    <div
                        draggable
                        onDragStart={props.handleDrag}
                        className={`col-lg-3 col-md-4 col-sm-6 col_searchCard_otr col_searchCard_inr2  order-box   ${(localStorage.getItem('aktivitet-side') === activity.id ||
                            localStorage.getItem('aktiviteter') === activity.id) &&
                            (window.location.pathname === '/aktivitet-side' ||
                                window.location.pathname === '/aktiviteter')
                            ? "scrollToActivity"
                            : ""
                            }`}
                    >
                        {/*<button id="x" onClick={props.handleDeleteActivity}>*/}
                        {/*    <i class="ri-close-line"></i>*/}
                        {/*</button>*/}


                        <div className={`outer-elemt2 ${!props.isVelgDisable && !activity.isVelgClick ? 'disabled-container' : ''} ${activity.isVelgClick ? 'liked-section' : ''}`}>

                            {/*<button id="x" onClick={props.handleDeleteActivity}>*/}
                            {/*    < i class="ri-thumb-up-line"></i>*/}
                            {/*</button>*/}

                            <h5 class="header-circle hoverid761-header top-datesec">
                                <b>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                                        <h5 className="header-circle hoverid761-header top-datesec" style={{ margin: 0, width: "100%", textAlign: "center" }}>
                                            <b>
                                                {activity?.addDate && dayjs(activity.addDate).isValid()
                                                    ? dayjs(activity.addDate).locale('nb').format('DD MMM')
                                                    : 'Invalid date'}{' '}
                                                {activity?.fromTime ? activity.fromTime : 'N/A'} - {activity?.toTime ? activity.toTime : 'N/A'}
                                            </b>
                                        </h5>
                                        <i
                                            className="ri-calendar-event-line edit_icon"
                                            style={{ cursor: "pointer", fontSize: "1.1em", marginLeft: "8px" }}
                                            onClick={() => setShowDropdown(prev => !prev)}
                                        />
                                    </div>

                                    {showDropdown && (
                                        <div 
                                            ref={dropdownRef}
                                            className="out-box-merge"
                                            style={{
                                                position: 'absolute',
                                                backgroundColor: 'white',
                                                color: 'gray',
                                                border: '1px solid #ccc',
                                                padding: '10px',
                                                zIndex: 1000,
                                                marginLeft: '-11px',
                                                width: '341px', // or any desired width
                                                zoom: '0.87',
                                                marginTop: '7px',

                                            }}
                                        >
                                            <button
                                                onClick={() => setShowDropdown(false)}
                                                style={{
                                                    position: 'absolute',
                                                    top: '8px',
                                                    right: '8px',
                                                    background: 'transparent',
                                                    border: 'none',
                                                    fontSize: '1.2em',
                                                    cursor: 'pointer',
                                                    color: '#999'
                                                }}
                                                aria-label="Close"
                                            >
                                                &times; {/* or use an icon */}
                                            </button>
                                            {/* Date Picker */}
                                            <CalenderComponent
                                                setSelectedDate={(date) => setTempAddDate(date)}
                                                selectedDate={tempAddDate}
                                                setShowCalender={() => { }}
                                            />

                                            {/* Time Range Selector */}
                                            <TimeRangeSelector
                                                labelFrom="TID"
                                                labelTo="TIL"
                                                fromTime={tempFromTime}
                                                toTime={tempToTime}
                                                setFromTime={(time) => setTempFromTime(time)}
                                                setToTime={(time) => setTempToTime(time)}
                                            />

                                            {/* Close Button */}
                                            <div style={{ marginTop: '10px', textAlign: 'right' }}>
                                                <button
                                                    className={`${(!tempAddDate && !tempFromTime && !tempToTime || (tempFromTime >= tempToTime)) ? "disabled" : ""}`}
                                                    onClick={() => {
                                                        // Save temporary values to activity
                                                        activity.addDate = tempAddDate ? tempAddDate.toISOString() : null;
                                                        activity.fromTime = tempFromTime;
                                                        activity.toTime = tempToTime;
                                                        props.onDateChange(activity.addDate);
                                                        setShowDropdown(false);
                                                    }}
                                                    style={{
                                                        padding: '8px 16px',
                                                        backgroundColor: '#7731b6',
                                                        width:'100%',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        cursor: 'pointer',
                                                        fontSize: '14px'
                                                    }}
                                                >
                                                    Lukk
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                {/*    {dayjs(activity.addDate).locale('nb').format('DD MMMM')}*/}
                                </b>
                            </h5>

                            <div>
                                <div className="position-relative img_otr">
                                    <div className="card-menu">
                                        {activity.isVelgClick && (
                                            <>
                                                <div
                                                    className="m9 edit_icon_otr icon_otr" onClick={props.handleActivityEditClick}>
                                                    < i class="ri-pencil-line  edit_icon"></i>
                                                </div>

                                                
                                            </>)}
                                        <div
                                            className="m9 edit_icon_otr icon_otr"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (props.source === "customer" || props.source === "partner") {
                                                    toActivityDetails();
                                                    localStorage.setItem('aktiviteter', activity.id);
                                                }
                                            }}
                                        >
                                            <i className="ri-eye-line edit_icon"></i>
                                        </div>
                                    </div>
                                    <Link
                                        className=""
                                        to={toActivityDetailsURL()}
                                        onClick={(e) => {
                                            if (activity.isCustomActivity && props.onShowCustomActivityDetails) {
                                                e.preventDefault();
                                                props.onShowCustomActivityDetails(activity);
                                            }
                                        }}
                                    >
                                        <img 
                                            className="card_imgS"
                                            src={imageError ? fallbackImage : props.CardImg.replace("{baseApiURL}", "https://funtlers.com/")}
                                            alt="img"
                                            //loading="eager"
                                      
                                            onLoad={() => setImageLoaded(true)} // Triggers when image fully loads
                                            onError={() => setImageError(true)} // If image fails, show fallback

                                            />
                                    </Link>
                                    {activity.discountPercent > 0 && activity.discountPercent < 100 && (
                                        <div>
                                            {/*    <p className="rabat_card_info shadow">-{activity.discountPercent}%</p>*/}
                                        </div>
                                    )}
                                </div>
                                <div className="content">
                                    <Link
                                        className="heading-lb card_heading"
                                        to={toActivityDetailsURL()}
                                        onClick={(e) => {
                                            if (activity.isCustomActivity && props.onShowCustomActivityDetails) {
                                                e.preventDefault();
                                                props.onShowCustomActivityDetails(activity);
                                            }
                                        }}
                                    >
                                        {props.CardHeading}
                                    </Link>
                                    <div className="d-flex flex-row justify-content-between p-3 mid">
                                        <div className="d-flex flex-column align-left">
                                            <small className="text-muted "><b>PRIS:</b></small>
                                            <div className="d-flex flex-row">

                                                <div className="d-flex flex-column ml-1 ">
                                                    <small className="ghj f-12">{props.CardDesc}</small>
                                                </div>
                                            </div>

                                            <small className="text-muted "><b>ANTALL:</b></small>
                                            <div className="d-flex flex-row">

                                                <div className="d-flex flex-column ml-1 ">
                                                    <small className="ghj f-12">{(activity.minPerson + activity.totPersons)}</small>
                                                </div>
                                            </div>

                                            <small className="text-muted"><b>TOTALSUM:</b></small>
                                            <div className="d-flex flex-row min-h-[46px]">
                                                <div className="d-flex flex-column ml-1 mb-1">
                                                    <small className="ghj f-12">{(activity?.price || 0) * (activity?.minPerson + activity.totPersons)} NOK</small>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="d-flex flex-column text-left">
                                            <small className="text-muted "><b>KATEGORI:</b></small>
                                            <div className="d-flex flex-column ml-1 text-left h-[64px]">
                                                {/*<i className={`sub-category-box2 ${activity?.isCustomActivity ? "ri-store-3-line" : props.CategoryDetails?.icon*/}
                                                {/*    }`}></i>*/}
                                                {/*<div className="d-flex flex-column ml-1">*/}
                                                    <small className="ghj fnt12">
                                                        {activity?.isCustomActivity ? "EGEN PLANLAGT AKTIVITET" : props.CategoryDetails?.value}
                                                    </small>
                                       {/*         </div>*/}
                                            </div>


                                            <small className="text-muted"><b>LOKASJON:</b></small>
                                            <div className="d-flex flex-column ml-1 text-left align-left">
                                                {/*<i className={`sub-category-box2 ${activity?.isCustomActivity ? "ri-store-3-line" : props.CategoryDetails?.icon*/}
                                                {/*    }`}></i>*/}
                                                {/*<div className="d-flex flex-column ml-1">*/}
                                                <small className="ghj fnt12 min-h-[46px]">
                                                    {
                                                        props.city.toLowerCase() === "all"
                                                            ? activity?.city
                                                                ? activity.city
                                                                    .split(',')
                                                                    .map((city) => {
                                                                        const trimmedCity = city.trim().toLowerCase();
                                                                        const matchedCity = getAllCities().find((obj) => obj.value === trimmedCity);
                                                                        return matchedCity ? matchedCity.label : '';
                                                                    })
                                                                    .filter(Boolean)
                                                                    .join(', ')
                                                                : ''
                                                            : props.city
                                                    }
                                                </small>
                                                {/*         </div>*/}
                                            </div>


                                        </div>

                                 

                                    </div>
                                </div>
                                <div className="dflex w-100" >
                                    {!activity.isVelgClick &&
                                        <ThemeBtn
                                            BtnClass={` like-dislike like ${activity.isVelgClick ? 'disabled' : ''}   ${!props.isVelgDisable && !activity?.isVelgClick ? 'disabled' : ''}`}
                                            BtnText={
                                                <>
                                                    <i className="ri-thumb-up-fill"></i>
                                                </>
                                            }
                                            onClick={props.clickFire}
                                        />
                                    }

                                    {activity.isVelgClick &&
                                        <div
                                            className={` like-dislike-selected    `}

                                        >
                                            <i className="ri-thumb-up-fill"></i> VALGT

                                        </div>
                                    }

                                    <ThemeBtn

                                        BtnClass={` like-dislike dislike ' 
                                        ${!props.isVelgDisable && !activity?.isVelgClick ? 'disabled' : ''
                                            }`.trim()}
                                        BtnText={(
                                            <>
                                                <i class="ri-thumb-down-fill"></i>

                                            </>
                                        )
                                        }
                                        onClick={props.handleDeleteActivity}
                                    />


                                   


                                </div>
                            </div>
                        </div>

                        {props.isManualOrder && (
                            <div>
                                <Link
                                    to={`/aktivitet/${res}?id=${activity.id}&isManualOrder=1`}
                                    className="Theme_btn_primary load_more_btn text-center"
                                >
                                    Manuell bestilling
                                </Link>
                            </div>
                        )}
                    </div>
                </>
            )}


            {props.isType && props.isType === "recommend-1" && props?.mode !== "isEditAdminRequest" && (
                <div
                    draggable
                    onDragStart={props.handleDrag}
                    className={`col-lg-3 col-md-4 col-sm-6 col_searchCard_otr col_searchCard_inr2     ${(localStorage.getItem('aktivitet-side') === activity.id ||
                        localStorage.getItem('aktiviteter') === activity.id) &&
                        (window.location.pathname === '/aktivitet-side' ||
                            window.location.pathname === '/aktiviteter')
                        ? "scrollToActivity"
                        : ""
                        }`}
                >

                    <div className={`outer-elemt2 ${!props.isVelgDisable && !activity.isVelgClick  ? 'disabled-container' : ''} ${activity.isVelgClick ? 'liked-section' : ''}`}>

                    

                        {/*<h5 class="header-circle hoverid761-header top-datesec"><b>{dayjs(activity.addDate).locale('nb').format('MMMM')}</b></h5>*/}

                        <div>
                            <div className="position-relative img_otr">
                                <div className="card-menu">
                                    {activity.isVelgClick && (
                                        <>
                                            <div
                                                className="m9 edit_icon_otr icon_otr" onClick={props.handleActivityEditClick}>
                                                < i class="ri-pencil-line  edit_icon"></i>
                                            </div>
                                        </>)}
                                    <div
                                        className="m9 edit_icon_otr icon_otr"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (props.source === "customer" || props.source === "partner") {
                                                toActivityDetails();
                                                localStorage.setItem('aktiviteter', activity.id);
                                            }
                                        }}
                                    >
                                        < i class="ri-eye-line edit_icon"></i>

                                    </div>
                                   
                                </div>
                                <Link
                                    className=""
                                    to={
                                        props.source === "customer" || props.source === "partner"
                                            ? `/aktivitet/${res}?id=${activity.id}&type=B2B`
                                            : "#"
                                    }
                                >
                                    <img
                                        className="card_imgS"
                                        src={imageError ? fallbackImage : props.CardImg.replace("{baseApiURL}", "https://funtlers.com/")}
                                        alt="img"
                                        //loading="eager"
                                       
                                        onLoad={() => setImageLoaded(true)} // Triggers when image fully loads
                                        onError={() => setImageError(true)} // If image fails, show fallback

                                    />
                                </Link>
                                {activity.discountPercent > 0 && activity.discountPercent < 100 && (
                                    <div>
                                        {/*    <p className="rabat_card_info shadow">-{activity.discountPercent}%</p>*/}
                                    </div>
                                )}
                            </div>
                            <div className="content">
                                <Link
                                    className="heading-lb card_heading"
                                    to={
                                        props.source === "customer" || props.source === "partner"
                                            ? `/aktivitet/${res}?id=${activity.id}&type=B2B`
                                            : "#"
                                    }
                                >
                                    {props.CardHeading}
                                </Link>
                                <div className="d-flex flex-row justify-content-between mid">
                                    <div className="d-flex flex-column align-left bd-r">
                                        <small className="text-muted "><b>PRIS:</b></small>
                                        <div className="d-flex flex-row">

                                            <div className="d-flex flex-column ml-1 mb-1">
                                                <small className="ghj">{props.CardDesc}</small>
                                            </div>
                                        </div>

                                        <small className="text-muted"><b>TOTALSUM:</b></small>
                                        <div className="d-flex flex-row">

                                            <div className="d-flex flex-column ml-1 mb-1">
                                                <small className="ghj h-43">{(activity?.price || 0) * (activity?.minPerson + activity.totPersons)} NOK</small>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="d-flex flex-column align-left">
                                        <small className="text-muted "><b>ANTALL:</b></small>
                                        <div className="d-flex flex-column">
                                            <div className="d-flex flex-column ml-1 mb-1">
                                                <small className="ghj">{(activity.minPerson + activity.totPersons)}</small>
                                            </div>
                                        </div>

                                        {activity.isVelgClick && (
                                            <>
                                                <small className="text-muted">
                                                    <b>DATO:</b>
                                                </small>
                                                <div className="d-flex flex-column">
                                                    <div className="d-flex flex-column ml-1 mb-1">
                                                        <small className="ghj fnt12">{DateFormat(activity.addDate)}</small>
                                                    </div>
                                                </div>
                                            </>
                                        )}



                                    </div>

                                </div>

                                {activity?.reason ? (
                                    <div
                                        className="admin-comment mb-4 flex items-start gap-2 p-2 rounded-md bg-gray-50 border border-gray-200"
                                        style={{ minHeight: "60px", maxWidth: "100%", marginTop: "-2px" }}
                                    >
                                        <i className="ri-chat-1-line text-purple text-lg mt-1"></i>

                                        <div className="flex-1 overflow-hidden">
                                            <b className="text-purple block mb-1">
                                                {!activity?.isCanceled ? "Brukerkommentarer:" : "Funtlers kommentar:"}
                                            </b>

                                            <p
                                                className="mb-0 text-gray-700 break-words whitespace-pre-line"
                                                style={{ wordBreak: "break-word" }}
                                            >
                                                {activity.reason}
                                            </p>
                                        </div>
                                    </div>
                                ) : (
                                      <div
                                    >
                                    </div>
                                )}

                            </div>

                            <div className="dflex w-100" >

                                {!activity.isVelgClick &&
                                    <ThemeBtn
                                        BtnClass={` like-dislike like ${activity.isVelgClick ? 'disabled' : ''}   ${!props.isVelgDisable && !activity?.isVelgClick ? 'disabled' : ''}`}
                                        BtnText={
                                            <>
                                                <i className="ri-thumb-up-fill"></i>
                                            </>
                                        }
                                        onClick={props.clickFire}
                                    />
                                }

                                {activity.isVelgClick &&
                                    <div
                                        className={` like-dislike-selected `}
                                    
                                    >
                                        <i className="ri-thumb-up-fill"></i> VALGT

                                    </div>
                                }

                                <ThemeBtn

                                    BtnClass={` like-dislike dislike ' 
                                        ${!props.isVelgDisable && !activity?.isVelgClick ? 'disabled' : ''
                                        }`.trim()}
                                    BtnText={(
                                        <>
                                            <i class="ri-thumb-down-fill"></i>

                                        </>
                                    )
                                    }
                                    onClick={props.handleDeleteActivity}
                                />




                            </div>
                        </div>
                    </div>

                    {props.isManualOrder && (
                        <div>
                            <Link
                                to={`/aktivitet/${res}?id=${activity.id}&isManualOrder=1`}
                                className="Theme_btn_primary load_more_btn text-center"
                            >
                                Manuell bestilling
                            </Link>
                        </div>
                    )}
                </div>
            )}

            {(props.isType === "recommend-2" ) && props?.mode === "isEditAdminRequest" && (
                <div
                    draggable
                    onDragStart={props.handleDrag}
                    className={`col-lg-4 col-md-4 col-sm-6 order-box ${(localStorage.getItem("aktivitet-side") === activity.id ||
                            localStorage.getItem("aktiviteter") === activity.id) &&
                            (window.location.pathname === "/aktivitet-side" ||
                                window.location.pathname === "/aktiviteter")
                            ? "scrollToActivity"
                            : ""
                        }`}
                >
                    <div
                        className={`booking-card ${!props.isVelgDisable && !activity.isVelgClick ? "disabled-container" : ""
                            } ${activity.isVelgClick ? "liked-section" : ""}`}
                    >
                        {/* ---- Heading + Edit ---- */}
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold text-purple">{props.CardHeading?.length > 16
                                ? props.CardHeading.slice(0,16) + "..."
                                : props.CardHeading}</h4>
                            {!activity?.isCanceled && (
                                <div className="flex items-center gap-3">
                                    <button
                                        onClick={props.handleDeleteActivity}
                                        className="p-2 rounded-full hover:bg-purple-100 transition"
                                        title="Delete Activity"
                                    >
                                        <i className="ri-delete-bin-line text-purple text-lg"></i>
                                    </button>

                                    <button
                                        onClick={props.handleActivityEditClick}
                                        className="p-2 rounded-full hover:bg-purple-100 transition"
                                        title="Edit Activity"
                                    >
                                        <i className="ri-pencil-line text-purple text-lg"></i>
                                    </button>
                                </div>
                            )}

                        </div>

                        {/* ---- Status ---- */}
                    <div> {/* reserve space */}
                        {activity?.isCanceled ? (
                            <span
                                className="badge-status"
                                    style={{ backgroundColor: "#cf505d", color: "white", minHeight: "28px" }}
                            >
                                    Kansellert
                            </span>
                        ) : (
                            <span className="badge-status invisible"></span>
                        )}
                    </div>


                        {/* ---- Date + Time ---- */}
                        <div className="detail-row">
                            <i className="ri-calendar-event-line"></i>
                            <span class="fw-bold">
                                {activity?.addDate
                                    ? dayjs(activity.addDate).locale("nb").format("DD. MMMM YYYY").toUpperCase()
                                    : "N/A"}
                            </span>
                          </div>

                        {/* ---- Date + Time ---- */}
                        <div className="detail-row">
                            
                            <i className="ri-time-line"></i>
                            <span class="fw-bold">
                                {activity?.fromTime || "N/A"} - {activity?.toTime || "N/A"}
                            </span>
                        </div>


                        {/* ---- Personer + Location ---- */}
                        <div className="detail-row">
                            <i className="ri-user-line"></i>
                            <span class="fw-bold">{(activity?.minPerson || 0) + (activity?.totPersons || 0)} personer</span>
                         
                        </div>

                        {/* ---- Personer + Location ---- */}
                        <div className="detail-row">
                       
                            <i className="ri-map-pin-line "></i>
                            <span class="fw-bold">{activity?.city?.toUpperCase() || "N/A"}</span>
                        </div>

                        {/* ---- Kategori ---- */}
                        <div className="detail-row">
                            <span class="fw-bold">Kategori:</span>
                            <b className="text-purple">{props.CategoryDetails?.value || "N/A"}</b>
                        </div>

                        {/* ---- Pris per person ---- */}
                        <div className="detail-row">
                            <span class="fw-bold">Pris per person:</span>
                            <b className="text-purple">{activity?.price || 0} NOK</b>
                        </div>

                        <hr />

                        {/* ---- Total aktivitet ---- */}
                        <div className="d-flex justify-content-between fw-bold">
                            <span>Total aktivitet:</span>
                            <span className="text-purple">
                                {(activity?.price || 0) *
                                    ((activity?.minPerson || 0) + (activity?.totPersons || 0))}{" "}
                                NOK
                            </span>
                        </div>

                        {/* ---- Funtlers kommentar ---- */}
                        <div
                            className="admin-comment mt-3 flex items-start gap-2 p-2 rounded-md bg-gray-50 border border-gray-200"
                            style={{ minHeight: "60px", maxWidth: "100%" }}
                        >
                            <i className="ri-chat-1-line text-purple text-lg mt-1"></i>

                            <div className="flex-1 overflow-hidden">
                                <b className="text-purple block mb-1">{!activity?.isCanceled ? 'Brukerkommentarer:' : 'Funtlers kommentar:'} </b>
                                {activity?.reason ? (
                                    <p
                                        className="mb-0 text-gray-700 break-words whitespace-pre-line"
                                        style={{ wordBreak: "break-word" }}
                                    >
                                        {activity.reason}
                                    </p>
                                ) : (
                                    <p className="mb-0 text-gray-400 italic">Ingen kommentar</p>
                                )}
                            </div>
                        </div>


                    </div>
                </div>
            )}


            {( props.isType === "recommend-1") && props?.mode === "isEditAdminRequest" && (
                <div
                    draggable
                    onDragStart={props.handleDrag}
                    className={`col-lg-4 col-md-4 col-sm-6 order-box ${(localStorage.getItem("aktivitet-side") === activity.id ||
                        localStorage.getItem("aktiviteter") === activity.id) &&
                        (window.location.pathname === "/aktivitet-side" ||
                            window.location.pathname === "/aktiviteter")
                        ? "scrollToActivity"
                        : ""
                        }`}
                >
                    <div
                        className={`booking-card ${!props.isVelgDisable && !activity.isVelgClick ? "disabled-container" : ""
                            } ${activity.isVelgClick ? "liked-section" : ""}`}
                    >
                        {/* ---- Heading + Edit ---- */}
                        <div className="d-flex justify-content-between align-items-center">
                            <h4 className="fw-bold text-purple">{props.CardHeading?.length > 16
                                ? props.CardHeading.slice(0,16) + "..."
                                : props.CardHeading}</h4>
                            {!activity?.isCanceled && (
                                <div className="flex items-center gap-3">
                                    <button
                                        onClick={props.handleDeleteActivity}
                                        className="p-2 rounded-full hover:bg-purple-100 transition"
                                        title="Delete Activity"
                                    >
                                        <i className="ri-delete-bin-line text-purple text-lg"></i>
                                    </button>

                                    <button
                                        onClick={props.handleActivityEditClick}
                                        className="p-2 rounded-full hover:bg-purple-100 transition"
                                        title="Edit Activity"
                                    >
                                        <i className="ri-pencil-line text-purple text-lg"></i>
                                    </button>
                                </div>
                            )}

                        </div>

                        {/* ---- Status ---- */}
                        <div > {/* reserve space */}
                            {activity?.isCanceled ? (
                                <span
                                    className="badge-status"
                                    style={{ backgroundColor: "#cf505d", color: "white", minHeight: "28px" }}
                                >
                                    Kansellert
                                </span>
                            ) : (
                                <span className="badge-status invisible"></span>
                            )}
                        </div>


                        {/* ---- Date + Time ---- */}
                        <div className="detail-row">
                            <i className="ri-calendar-event-line"></i>
                            <span class="fw-bold">
                                {activity?.addDate
                                    ? dayjs(activity.addDate).locale("nb").format("DD. MMMM YYYY").toUpperCase()
                                    : "N/A"}
                            </span>
                        </div>

                        {/* ---- Date + Time ---- */}
                        <div className="detail-row">

                            <i className="ri-time-line"></i>
                            <span class="fw-bold">
                                {activity?.fromTime || "N/A"} - {activity?.toTime || "N/A"}
                            </span>
                        </div>


                        {/* ---- Personer + Location ---- */}
                        <div className="detail-row">
                            <i className="ri-user-line"></i>
                            <span class="fw-bold">{(activity?.minPerson || 0) + (activity?.totPersons || 0)} personer</span>

                        </div>

                        {/* ---- Personer + Location ---- */}
                        <div className="detail-row">

                            <i className="ri-map-pin-line "></i>
                            <span class="fw-bold">{activity?.city?.toUpperCase() || "N/A"}</span>
                        </div>

                        {/* ---- Kategori ---- */}
                        <div className="detail-row">
                            <span class="fw-bold">Kategori:</span>
                            <b className="text-purple">{props.CategoryDetails?.value || "N/A"}</b>
                        </div>

                        {/* ---- Pris per person ---- */}
                        <div className="detail-row">
                            <span class="fw-bold">Pris per person:</span>
                            <b className="text-purple">{activity?.price || 0} NOK</b>
                        </div>

                        <hr />

                        {/* ---- Total aktivitet ---- */}
                        <div className="d-flex justify-content-between fw-bold">
                            <span>Total aktivitet:</span>
                            <span className="text-purple">
                                {(activity?.price || 0) *
                                    ((activity?.minPerson || 0) + (activity?.totPersons || 0))}{" "}
                                NOK
                            </span>
                        </div>

                        {/* ---- Funtlers kommentar ---- */}
                        <div
                            className="admin-comment mt-3 flex items-start gap-2 p-2 rounded-md bg-gray-50 border border-gray-200"
                            style={{ minHeight: "60px", maxWidth: "100%", fontSize: "18px"}}
                        >
                            <i className="ri-chat-1-line text-purple text-lg mt-1"></i>

                            <div className="flex-1 overflow-hidden">
                                <b className="text-purple block mb-1">{!activity?.isCanceled ? 'Brukerkommentarer:' : 'Funtlers kommentar:'} </b>
                                {activity?.reason ? (
                                    <p
                                        className="mb-0 text-gray-700 break-words whitespace-pre-line"
                                        style={{ wordBreak: "break-word" }}
                                    >
                                        {activity.reason}
                                    </p>
                                ) : (
                                    <p className="mb-0 text-gray-400 italic">Ingen kommentar</p>
                                )}
                            </div>
                        </div>


                    </div>
                </div>
            )}


            {props.isType && props.isType === "recommend-1" && props?.mode === "isEditAdminRequest" && false && (
                <div
                    draggable
                    onDragStart={props.handleDrag}
                    className={`col-lg-4 col-md-4 col-sm-6 col_searchCard_otr col_searchCard_inr2     ${(localStorage.getItem('aktivitet-side') === activity.id ||
                        localStorage.getItem('aktiviteter') === activity.id) &&
                        (window.location.pathname === '/aktivitet-side' ||
                            window.location.pathname === '/aktiviteter')
                        ? "scrollToActivity"
                        : ""
                        }`}
                >

                    <div className={`outer-elemt2 ${!props.isVelgDisable && !activity.isVelgClick ? 'disabled-container' : ''} ${activity.isVelgClick ? 'liked-section' : ''}`}>



                        {/*<h5 class="header-circle hoverid761-header top-datesec"><b>{dayjs(activity.addDate).locale('nb').format('MMMM')}</b></h5>*/}

                        <div>
                            <div className="position-relative img_otr">
                                <div className="card-menu">
                                    {activity.isVelgClick && (
                                        <>
                                            <div
                                                className="m9 edit_icon_otr icon_otr" onClick={props.handleActivityEditClick}>
                                                < i class="ri-pencil-line  edit_icon"></i>
                                            </div>
                                        </>)}
                                    <div
                                        className="m9 edit_icon_otr icon_otr"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (props.source === "customer" || props.source === "partner") {
                                                toActivityDetails();
                                                localStorage.setItem('aktiviteter', activity.id);
                                            }
                                        }}
                                    >
                                        < i class="ri-eye-line edit_icon"></i>

                                    </div>

                                </div>
                                <Link
                                    className=""
                                    to={
                                        props.source === "customer" || props.source === "partner"
                                            ? `/aktivitet/${res}?id=${activity.id}&type=B2B`
                                            : "#"
                                    }
                                >
                                    <img
                                        className="card_imgS"
                                        src={imageError ? fallbackImage : props.CardImg.replace("{baseApiURL}", "https://funtlers.com/")}
                                        alt="img"
                                        //loading="eager"
                                       
                                        onLoad={() => setImageLoaded(true)} // Triggers when image fully loads
                                        onError={() => setImageError(true)} // If image fails, show fallback

                                    />
                                </Link>
                                {activity.discountPercent > 0 && activity.discountPercent < 100 && (
                                    <div>
                                        {/*    <p className="rabat_card_info shadow">-{activity.discountPercent}%</p>*/}
                                    </div>
                                )}
                            </div>
                            <div className="content">
                                <Link
                                    className="heading-lb card_heading"
                                    to={
                                        props.source === "customer" || props.source === "partner"
                                            ? `/aktivitet/${res}?id=${activity.id}&type=B2B`
                                            : "#"
                                    }
                                >
                                    {props.CardHeading}
                                </Link>
                                <div className="d-flex flex-row justify-content-between mid">
                                    <div className="d-flex flex-column align-left bd-r">
                                        <small className="text-muted "><b>PRIS:</b></small>
                                        <div className="d-flex flex-row">

                                            <div className="d-flex flex-column ml-1 mb-1">
                                                <small className="ghj">{props.CardDesc}</small>
                                            </div>
                                        </div>

                                        <small className="text-muted"><b>TOTALSUM:</b></small>
                                        <div className="d-flex flex-row">

                                            <div className="d-flex flex-column ml-1 mb-1">
                                                <small className="ghj h-43">{(activity?.price || 0) * (activity?.minPerson + activity.totPersons)} NOK</small>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="d-flex flex-column align-left">
                                        <small className="text-muted "><b>ANTALL:</b></small>
                                        <div className="d-flex flex-column">
                                            <div className="d-flex flex-column ml-1 mb-1">
                                                <small className="ghj">{(activity.minPerson + activity.totPersons)}</small>
                                            </div>
                                        </div>

                                      


                                        {/* ---- Funtlers kommentar ---- */}
                                      

                                    </div>
                                   
                                </div>
                                {activity.isVelgClick && <div
                                    className="admin-comment mt-3 flex items-start gap-2 p-2 rounded-md bg-gray-50 border border-gray-200"
                                    style={{ minHeight: "60px", maxWidth: "100%", fontSize: "18px" }}
                                >
                                    <i className="ri-chat-1-line text-purple text-lg mt-1"></i>

                                    <div className="flex-1 overflow-hidden">
                                        <b className="text-purple block mb-1">{!activity?.isCanceled ? 'Brukerkommentarer:' : 'Funtlers kommentar:'} </b>
                                        {activity?.reason ? (
                                            <p
                                                className="mb-0 text-gray-700 break-words whitespace-pre-line"
                                                style={{ wordBreak: "break-word" }}
                                            >
                                                {activity.reason}
                                            </p>
                                        ) : (
                                            <p className="mb-0 text-gray-400 italic">Ingen kommentar</p>
                                        )}
                                    </div>
                                </div>}
                            </div>
                            <div className="dflex w-100" >

                                {!activity.isVelgClick &&
                                    <ThemeBtn
                                        BtnClass={` like-dislike like ${activity.isVelgClick ? 'disabled' : ''}   ${!props.isVelgDisable && !activity?.isVelgClick ? 'disabled' : ''}`}
                                        BtnText={
                                            <>
                                                <i className="ri-thumb-up-fill"></i>
                                            </>
                                        }
                                        onClick={props.clickFire}
                                    />
                                }

                                {activity.isVelgClick &&
                                    <div
                                        className={` like-dislike-selected `}

                                    >
                                        <i className="ri-thumb-up-fill"></i> VALGT

                                    </div>
                                }

                                <ThemeBtn

                                    BtnClass={` like-dislike dislike ' 
                                        ${!props.isVelgDisable && !activity?.isVelgClick ? 'disabled' : ''
                                        }`.trim()}
                                    BtnText={(
                                        <>
                                            <i class="ri-thumb-down-fill"></i>

                                        </>
                                    )
                                    }
                                    onClick={props.handleDeleteActivity}
                                />




                            </div>
                        </div>
                    </div>

                    {props.isManualOrder && (
                        <div>
                            <Link
                                to={`/aktivitet/${res}?id=${activity.id}&isManualOrder=1`}
                                className="Theme_btn_primary load_more_btn text-center"
                            >
                                Manuell bestilling
                            </Link>
                        </div>
                    )}
                </div>
            )}

        
            {!props.isType && <div draggable onDragStart={props.handleDrag} className={` col-lg-3 col-md-4 col-sm-6 col_searchCard_otr col_searchCard_inr ${(localStorage.getItem('aktivitet-side') === activity.id || localStorage.getItem('aktiviteter') === activity.id) &&
                (window.location.pathname === '/aktivitet-side' || window.location.pathname === '/aktiviteter')
                ? "scrollToActivity"
                : ""
                }`}>

                <div className={`outer-elemt outer-element-other-main ${!props.isVelgDisable && !props.isVelgDisable  ? 'disabled-container' : ''}`}>

                    <div>
                        <div className="position-relative img_otr">

                            <div class="card-menu " >

                                <div className={`m9 edit_icon_otr icon_otr`} onClick={(e) => {
                                    
                                    e.stopPropagation(); // Add this line to stop event propagation
                                    if (props.source === "customer" || props.source === "partner") {
                                        toActivityDetails();
                                        return localStorage.setItem('aktiviteter', activity.id);
                                    }

                                }}>
                                    <i className={`ri-eye-line  edit_icon`}></i>
                                </div>

                            </div>
                            <img
                                className="card_imgS"
                                src={imageError ? fallbackImage : props.CardImg.replace("{baseApiURL}", "https://funtlers.com/")}
                                alt="img"
                                //loading="eager"
                             
                                onLoad={() => setImageLoaded(true)} // Triggers when image fully loads
                                onError={() => setImageError(true)} // If image fails, show fallback

                            />
                            {activity.discountPercent > 0 && activity.discountPercent < 100 ? <div><p className="rabat_card_info shadow">-{activity.discountPercent}%</p></div> : ""}
                        </div>
                        <div className="content">
                            <Link className="heading-lb card_heading" to={props.source === "customer" || props.source === "partner" ? "/aktivitet/" + res + "?id=" + activity.id + "&type=B2B" : ""}>{props.CardHeading}</Link>
                            <p className="heading-s card_desc_activity text-center">
                                {props.CardDesc}
                            </p>
                        </div>

                        <div>
                            <ThemeBtn
                                BtnClass={`Theme_btn_primary w-100 send_btn ${!activity.isVelgClick ? '' : 'Theme_btn_black'} ${!props.isVelgDisable ? 'disabled' : ''}`}
                                BtnText={!activity.isVelgClick ? "VELG" : "VALGT"}
                                onClick={!activity.isVelgClick ? props.clickFire : undefined}
                            />

                        </div>



                    </div>
                </div>
                {
                    props.isManualOrder === "true" && (
                        <div>
                            <Link to={"/aktivitet/" + res + "?id=" + activity.id + "&isManualOrder=1"} class="Theme_btn_primary load_more_btn text-center" >
                                Manuell bestilling
                            </Link>
                        </div>
                    )
                }
            </div>}

        </>
    )
    

}

export default OrderPlanSearchResultCard;
